import script from "./Indicator.vue?vue&type=script&lang=ts&setup=true"
export * from "./Indicator.vue?vue&type=script&lang=ts&setup=true"

import "./Indicator.vue?vue&type=style&index=0&id=48d5c963&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48d5c963"]])

export default __exports__